import noReportListService from "./noReportListService";

const noReportService = [
    ...noReportListService
];

export { noReportService as default, noReportListService }